/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

import { useAppDispatch } from 'redux/hooks'
import { setAlertMessages, setAlertTime, setAlertType } from 'redux/ui/common/alertUI'

import { AlertMessages } from 'types'

export const useErrorAlert = (error: any, time = 6000) => {
  const dispatch = useAppDispatch()

  const handleError = (error: AlertMessages) => {
    dispatch(setAlertMessages(error?.data))
    dispatch(setAlertType('error'))
    dispatch(setAlertTime(time))
  }

  useEffect(() => {
    error && handleError(error as AlertMessages)
  }, [error])
}
